import {SxProps} from '@mui/material';

import {greenColors} from '../../../layouts/theme/designSystem';

export const bodyPdf: SxProps = {
  fontSize: '15px',
  lineHeight: '22px',
  fontWeight: 400,
  color: `${greenColors[700]}`,
};

export const pdfH1: SxProps = {
  fontSize: '34px',
  fontWeight: 700,
  lineHeight: '51px',
  color: `${greenColors[700]}`,
};

export const pdfH2: SxProps = {
  fontSize: '21px',
  fontWeight: 400,
  lineHeight: '24px',
  color: `${greenColors[700]}`,
};

export const pdfH3: SxProps = {
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '27px',
  color: `${greenColors[700]}`,
};

export const pdfH4: SxProps = {
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '30px',
  color: `${greenColors[700]}`,
};

export const bodyPdfExtraLineHeight: SxProps = {
  ...bodyPdf,
  lineHeight: '25px',
};

export const greenGradient: SxProps = {
  backgroundImage: 'radial-gradient(circle at top, #3C7077 0%, #163438 60%)',
};

export const greenGradientReverse: SxProps = {
  backgroundImage: 'radial-gradient(circle at bottom, #3C7077 0%, #163438 60%)',
};

export const greenGradientTopLeft: SxProps = {
  backgroundImage: 'linear-gradient(to top left, #163438 60%, #3C7077 100%)',
};

export const orangeGradient: SxProps = {
  backgroundImage: 'linear-gradient(to top right, #D94D00 60%, #E88B58 100%)',
};

export const pdfPrintPage: SxProps = {
  boxSizing: 'border-box',
  margin: '0 auto',
  maxWidth: '210mm',
  minHeight: '297mm',
  width: '100%',
};
